import { RootState } from 'reduxStore/store';

const getIsAuth = (state: RootState) => !!state.auth.token;
const getEmail = (state: RootState) => state.auth.email;
const getDomain = (state: RootState) => state.auth.email?.split('@')[1] || null;
const getToken = (state: RootState) => state.auth.token;
const getAuthError = (state: RootState) => state.auth.error;

export { getIsAuth, getEmail, getDomain, getToken, getAuthError };
